import { Fragment, useEffect, useState } from "react";
import useMediaQuery from "../hooks/useMediaQuery";

// Dark announcement bar. Static (scrolls away); the nav below it is what sticks.
//
// Desktop shows all four facts in a row split by thin dividers. A phone has room
// for one, so instead of hiding three of them it slides through the same list,
// one line at a time. Paused under reduced motion and while the tab is hidden.
//
// Origin wording: "Australian made", never "All Australian made" or "100%".
// The angle is Duragal and the fabrication happens in Victoria, but the tube is
// imported, so a claim that covers everything would overreach (Tanner,
// 2026-09-14). Keep the qualifier off it.
const ITEMS = [
  { text: "Australian family-owned", strong: true },
  { text: "Australian made", strong: true },
  { text: "Shipping Australia-wide" },
  { text: "Global enquiries welcome" },
];

const ROTATE_MS = 4200;

export default function AnnouncementBar() {
  const isPhone = useMediaQuery("(max-width: 760px)");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!isPhone) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const timer = window.setInterval(() => {
      if (!document.hidden) setIndex((i) => (i + 1) % ITEMS.length);
    }, ROTATE_MS);
    return () => window.clearInterval(timer);
  }, [isPhone]);

  return (
    <div className="pd-announce" data-testid="announce-bar">
      <div className="pd-announce-inner" data-testid="announce-text">
        {isPhone ? (
          <div className="pd-announce-rotator">
            <div className="pd-announce-track" style={{ transform: `translateY(calc(var(--pd-announce-row) * -${index}))` }}>
              {ITEMS.map((item, i) => (
                <span
                  key={item.text}
                  className={item.strong ? "pd-announce-strong" : undefined}
                  aria-hidden={i !== index ? "true" : undefined}
                >
                  {item.text}
                </span>
              ))}
            </div>
          </div>
        ) : (
          ITEMS.map((item, i) => (
            <Fragment key={item.text}>
              {i > 0 && <span aria-hidden="true" className="pd-announce-sep" />}
              <span className={item.strong ? "pd-announce-strong" : undefined}>{item.text}</span>
            </Fragment>
          ))
        )}
      </div>
    </div>
  );
}
